// extracted by mini-css-extract-plugin
module.exports = {"title":"pureflo_title__TQmY1","wrapper":"pureflo_wrapper__1ZQRF"};